<template>
  <b-card>
    <b-card-img
      :src="holder.cover || errorImage"
      alt="Profile Cover Photo"
      top
      :height="$route.path.includes('live') ? '103' : '190'"
      @error="setAltImg"
      class="mb-2 rounded"
    />
    <div class="profile-image-wrapper d-flex align-items-center flex-wrap">
      <div
        :class="`profile-image   p-0 ${
          $route.path.includes('live') ? 'mb-0' : ''
        }`"
      >
        <b-img
          :src="holder.logo ? holder.logo : errorImage"
          @error="setAltImg"
          style="border: 2px solid #fbad25 !important"
          alt="profile photo"
          class="rounded-avatar p-25 mr-2"
          width="84"
          height="84"
        />
      </div>

      <div>
        <b-skeleton
          height="20px"
          width="140px"
          class="mx-auto mb-50"
          v-if="loading"
        />
        <h4 v-else class="py-sm-0 py-50">
          <span v-if="holder.flag_url">
            <b-img
              class="rounded-circle"
              width="28"
              height="28"
              :src="holder.flag_url || errorImage"
              @error="setAltImg"
            />
          </span>
          {{ holder.name || "-" }}
        </h4>
        <b-skeleton
          height="20px"
          width="120px"
          class="mx-auto mb-50"
          v-if="loading"
        />
        <h6 v-else class="text-muted">
          {{ holder.email }}
          <b-badge v-if="true" variant="warning" class="rounded-circle p-25">
            <feather-icon icon="CheckIcon" style="width: 12px; height: 12px" />
          </b-badge>
        </h6>
      </div>
    </div>

    <template v-if="!$route.path.includes('live')">
      <div
        class="d-flex justify-content-between align-items-center mt-md-2 mt-1 p-2"
        style="
          text-align: center;
          border: 1px dashed #70707045;
          border-radius: 10px;
          background: #2a2a376e;
        "
      >
        <div>
          <b-skeleton
            height="20px"
            width="40px"
            class="mx-auto"
            v-if="loading"
          />
          <h3 class="mb-0" v-else>{{ holder.competitions_count }}</h3>
          <h6 class="font-weight-normal">competition held</h6>
        </div>
        <div>
          <b-skeleton
            height="20px"
            width="40px"
            class="mx-auto"
            v-if="loading"
          />
          <h3 class="mb-0" v-else>{{ holder.distributed_awards }}</h3>
          <h6 class="font-weight-normal">Distributed awards</h6>
        </div>
      </div>
    </template>
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BSkeleton,
  BImg,
  BCardImg,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BBadge,
    BImg,
    BAvatar,
    BSkeleton,
    BCardImg,
  },
  props: {
    holder: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
